import { ROLES_TYPE } from "./roles";

export const FEATURES = {
  MANUAL_SWAP: ROLES_TYPE.MANUAL_SWAP,
  BATTERY_MOVEMENT: ROLES_TYPE.BATTERY_MOVEMENT,
  CASH_COLLECTION: ROLES_TYPE.CASH_COLLECTION,
  DEALER: ROLES_TYPE.DEALER,
  DRIVER_LEAD_CREATION: ROLES_TYPE.DRIVER_LEAD_CREATION,
};

export const SUB_FEATURES = {
  [FEATURES.MANUAL_SWAP]: [
    ROLES_TYPE.MANUAL_SWAP_DIGITAL,
    ROLES_TYPE.MANUAL_SWAP_INVENTORY,
    ROLES_TYPE.MANUAL_SWAP_OTA,
  ],
  [FEATURES.DEALER]: [
    ROLES_TYPE.DRIVER_LEAD_CREATION,
    ROLES_TYPE.DRIVER_LEAD_VIEW,
  ],
  [FEATURES.DRIVER_LEAD_CREATION]: [ROLES_TYPE.DRIVER_LEAD_VIEW],
};
